import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2221fc84"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "project-tasks-layout" }
const _hoisted_2 = {
  key: 0,
  class: "project-tasks-layout__skeleton-content"
}
const _hoisted_3 = { class: "project-tasks-layout__content" }

import { onMounted, provide, ref, computed, watch, onUnmounted, onBeforeMount } from 'vue';
import { onBeforeRouteUpdate, RouteLocationNormalizedLoaded, useRouter } from 'vue-router';
import { SidebarMenu, SettingsBreadcrumbsModel, MenuBreadcrumbs } from '@/components';
import { AdapterService } from './adapter';
import { ProjectModel } from '@/models';
import { projectInjectKey } from '@/inject-keys';
import { GroupModel, QueueTasksModel } from '@/components/sidebar/models';
import { TirPmNotificationGroup, TirPmSkeletonLoader } from 'tir-components';
import { CurrentUser, UserRoleEnum } from 'tir-pm-user-core';
import CheckProjectAccessRequest from '@/models/CheckProjectAccessRequest';
import WeeekOptionsSwitchEnableRequest from '@/models/WeeekOptionsSwitchEnableRequest';
import MonitoringUserTasksPage from '@/pages/monitorings/monitoring-days/components/monitoring-user-tasks-page.vue';
import { CheckEstimateRequestModel } from './models';


export default /*#__PURE__*/_defineComponent({
  __name: 'project-tasks-layout',
  setup(__props) {

const router = useRouter();

const adapter = new AdapterService();

/**Настройки хлебных крошек */
const breadcrumbsSettings = ref<SettingsBreadcrumbsModel>();
/**Видны ли хлебные крошки */
const visibleBreadcrumb = ref(false);

/**Получить настройки хлебных крошек */
const getBreadcrumbsSettingsByRoute = (route?: RouteLocationNormalizedLoaded) => {
  if (!route) return;

  return new SettingsBreadcrumbsModel({
    NamespaceId: route.params?.namespaceId?.toString(),
    GroupId: route.params?.groupId ? Number(route.params.groupId) : undefined,
    QueueId: route.params?.queueId?.toString(),
  });
};

/**Ссылка на компонент сайбара */
const $sidebar = ref<InstanceType<typeof SidebarMenu>>();
/**Информация о проекте */
const project = ref<ProjectModel>();
/**Есть ли доступ к задаче */
const isUserAccessTask = ref<boolean>(true);
/**Отсутствие информации об очереди */
const isNoQueueInformation = ref(false);
/**Был ли приглашен текущий юзер */
const checkInviteUser = ref<boolean>();

/**Является ли юзер овнером */
const isOwner = CurrentUser.Roles.includes(UserRoleEnum.Owner);
provide('project', project);
/**Админ проекта */
const isAdminProject = computed(() => !!project.value?.Admins?.some((a) => a.Id == CurrentUser.Id));
/**id проекта */
const projectId = computed(() => Number(router.currentRoute.value.params?.projectId));
/**Проверка на нахождение на странице мониторинга */
const hasMonitoring = computed(() => router.currentRoute.value.path.includes('/monitoring'));
/**id выбраного юзера в мониторинге */
const selectedUserIdMonitoring = computed(() => Number(router.currentRoute.value.query.userId));
/**id задачи */
const taskId = computed(() => Number(router.currentRoute.value.params?.taskId));
/**Находится ли юзер в деталке задачи */
const isTaskDetailPage = computed(() => router.currentRoute.value.name === 'task-detail');
/**Находится ли юзер на странице с заглушкой */
const isOnStubPage = computed(() => router.currentRoute.value.name === 'project-stub-page');

provide('isAdminProject', isAdminProject);
/**Приглашен ли текущий юзер */
provide('isInvited', checkInviteUser);

provide(
  projectInjectKey,
  computed(() => project.value),
);

/**Получить проект */
const getProject = async (projectId: number) => {
  const resp = await adapter.getProject(projectId);
  if (resp.IsSuccess) {
    project.value = resp.Value;
  }
};
/**Проврека доступа к проекту */
const checkProjectAccess = async () => {
  const resp = await adapter.checkProjectAccess(
    new CheckProjectAccessRequest({
      ProjectId: projectId.value,
    }),
  );
  if (!resp?.HasAccess && !isOwner) {
    router.push('/projects');
    return;
  }
};
/**Проверка, приглашён ли текущий пользователь */
const checkInviteToEstimate = async () => {
  const resp = await adapter.checkInviteToEstimate(
    new CheckEstimateRequestModel({
      TaskId: taskId.value,
    }),
  );
  if (resp.IsSuccess) {
    checkInviteUser.value = resp.Value.Invite;
  }
};
/**Установить заголово для вкладки браузера */
const setDocumentTitle = () => {
  if (router.currentRoute.value.path.endsWith('/namespaces')) {
    if (project.value?.Name) {
      const maxTitleLength = 18;
      const projectName =
        project.value.Name.length > maxTitleLength
          ? project.value.Name.substring(0, maxTitleLength) + '...'
          : project.value.Name;

      document.title = `Проект: ${projectName}`;
    }
    if (!projectId.value) document.title = 'Проекты';
  }
};

watch(
  [() => router.currentRoute.value, () => project.value?.Name],
  () => {
    setDocumentTitle();
  },
  { immediate: true },
);
/**Отслеживание изменения id задачи */
watch(
  () => taskId.value && isTaskDetailPage.value,
  () => {
    if (taskId.value) {
      checkInviteToEstimate();
    }
  },
  { immediate: true },
);

/**Проверка на доступ к задаче */
const checkIsUserAccessTask = (value) => {
  isUserAccessTask.value = value;
};

/**Отсутсвие данных очереди */
const onQueueEmpty = (value) => {
  isNoQueueInformation.value = value;
};
/**Отслуживание изменение id проекта */
watch(
  () => projectId.value,
  async () => {
    if (projectId.value) await checkProjectAccess();
  },
  { immediate: true },
);

/**После рендера компонента */
onMounted(async () => {
  if (isNaN(projectId.value)) return;
  await getProject(projectId.value);
  breadcrumbsSettings.value = getBreadcrumbsSettingsByRoute(router.currentRoute.value);
  visibleBreadcrumb.value = true;
});

onBeforeRouteUpdate(async (to) => {
  isUserAccessTask.value = true;
  breadcrumbsSettings.value = getBreadcrumbsSettingsByRoute(to);
  const projectId = Number(to.params?.projectId);
  if (isNaN(projectId)) return;
  if (project.value.Id !== projectId) {
    await getProject(projectId);
  }
});

/**
 * * Переключение настройки включения/выключения интеграции с Weeek
 */
const switchEnableWeeek = async () => {
  const response = await adapter.switchEnableAsync(
    new WeeekOptionsSwitchEnableRequest({
      ProjectId: projectId.value,
    }),
  );
  if (response.IsSuccess) {
    project.value.WeekEnable = response.Value.WeeekEnable;
  }
};

const userData = ref();

const checkRightsFormQueue = (data) => {
  userData.value = data;
};

return (_ctx: any,_cache: any) => {
  const _component_RouterView = _resolveComponent("RouterView")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_unref(TirPmNotificationGroup), {
      group: "general",
      position: "top-right",
      zIndex: 20000
    }),
    (!project.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(_unref(TirPmSkeletonLoader), {
            width: "14rem",
            height: "5rem",
            borderRadius: "0.5rem"
          }),
          _createVNode(_unref(TirPmSkeletonLoader), {
            width: "42.375rem",
            height: "2rem",
            borderRadius: "0.5rem"
          })
        ]))
      : _createCommentVNode("", true),
    (project.value)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
          _createVNode(_unref(SidebarMenu), {
            ref_key: "$sidebar",
            ref: $sidebar
          }, null, 512),
          _createElementVNode("div", _hoisted_3, [
            (!hasMonitoring.value && !isOnStubPage.value)
              ? (_openBlock(), _createBlock(_unref(MenuBreadcrumbs), {
                  key: 0,
                  settings: breadcrumbsSettings.value,
                  project: project.value
                }, null, 8, ["settings", "project"]))
              : _createCommentVNode("", true),
            _createElementVNode("div", {
              class: _normalizeClass({ 'project-tasks-layout__main': !selectedUserIdMonitoring.value })
            }, [
              _createVNode(_component_RouterView, {
                project: project.value,
                userData: userData.value,
                isNoQueueInformation: isNoQueueInformation.value,
                isAccessWeeek: project.value.WeekEnable,
                onUpdateAllowImportWeeek: switchEnableWeeek,
                onCheckRightsFormQueue: checkRightsFormQueue,
                onUppdateProject: _cache[0] || (_cache[0] = ($event: any) => (getProject(projectId.value))),
                onIsNoQueueInformation: onQueueEmpty,
                onCheckIsUserAccessTask: checkIsUserAccessTask
              }, null, 8, ["project", "userData", "isNoQueueInformation", "isAccessWeeek"])
            ], 2)
          ])
        ], 64))
      : _createCommentVNode("", true)
  ]))
}
}

})